import { cloneDeep } from 'lodash'
import { UiSchema } from '@rjsf/utils'
import { AnyObject } from '@feedyou/utils'
import aiStepSchema from '@feedyou/schema/schema/steps/ai.json'

import { HIDDEN_WIDGET, useBaseSubstepUiSchema } from '../../../../../../features/schema'

export function useFormSchema() {
  const toolSubstepSchema = cloneDeep<any>(aiStepSchema.properties.tools.items)
  delete toolSubstepSchema.properties.id

  return toolSubstepSchema
}

export function useFormUiSchema(formData: AnyObject): UiSchema {
  const uiSchema = useBaseSubstepUiSchema()

  if (formData.action) {
    switch (formData.action.type) {
      case 'dialog':
        uiSchema.action = { dialog: { 'ui:widget': 'DialogCreatableSelectWidget' } }
        break
      case 'code':
        uiSchema.action = { code: { 'ui:widget': 'EditorJavascriptWidget' } }
        break
    }
  }

  uiSchema.parameters = { 'ui:widget': 'EditorJavascriptWidget' }
  uiSchema.action = { ...uiSchema.action, type: HIDDEN_WIDGET }
  return uiSchema
}
